;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.directives')
    .directive('zlUploadBox', UploadBoxDirective)

  UploadBoxController.$inject = ['$scope', 'zlAuth', 'urls', 'FileUploader']

  function UploadBoxController ($scope, zlAuth, urls, FileUploader) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        // Public attributes
        // Public functions
        showUpload: showUpload,
        notifyAuthChange: setHeaders
      })
      init()
    }

    function init () {

      if (!self.uploader) {
        var uploader = new FileUploader({
          url: urls.uploader + '/upload',
          autoUpload: true,
          alias: 'files',
          withCredentials: false
        })
        self.uploader = uploader
      }

      setHeaders()

      zlAuth.registerObserver(self)

      // zlAuth n'expose pas de désinscription : on retire l'instance directement du tableau
      // public des observers à la destruction, sinon zlAuth garde chaque box (et son uploader)
      // en mémoire et lui notifie les changements d'auth indéfiniment
      $scope.$on('$destroy', () => {
        if (Array.isArray(zlAuth.observers)) _.pull(zlAuth.observers, self)
      })

      self.uploader.onCompleteItem = function (fileItem, response, status, headers) {
        self.container = _.union(self.container, response)
        $scope.$emit('formModified')
      }
      self.uploader.onCompleteAll = function (fileItem, response, status, headers) {
        self.uploader.clearQueue()
      }
    }

    function setHeaders () {
      zlAuth.getToken().then(function (tokn) {
        self.uploader.headers = { 'Authorization': 'Bearer ' + tokn }
      })
    }
    function showUpload ($event) {
      var dataTransfer = $event.dataTransfer || $event.originalEvent.dataTransfer
      if (dataTransfer && _.includes(dataTransfer.types, 'Files')) {
        self.uploadActivated = true
      }
    }
  }

  UploadBoxDirective.$inject = []

  function UploadBoxDirective () {
    return {
      restrict: 'E',
      templateUrl: '/app/common/directives/upload-box/upload-box.html',
      controllerAs: 'box',
      controller: UploadBoxController,
      transclude: true,
      scope: {},
      bindToController: {
        container: '=',
        mini: '=',
        uploader: '='
      }
    }
  }
})(window.angular, window._)
